// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BankTwoToneSvg from "@fishx/icons-svg/es/asn/BankTwoTone";
import FishxIcon from '../components/FishxIcon';

var BankTwoTone = function BankTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BankTwoToneSvg
  }));
};

BankTwoTone.displayName = 'BankTwoTone';
export default React.forwardRef(BankTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BankTwoTone.js
// module id = 2049
// module chunks = 0